import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/Home.js';
import InitiativePage from './components/InitiativePage.js';
import Header from './components/Header.js';

const initiatives = [
	{
		path: `/Tryavna`,
		title: `Bulgarian Children's Hospital in Tryavna, Bulgaria`,
		content: [
			`Funds raised: $400`,
			`Supplies Purchased: educational resources and kitchen equipment`,
			`In our first 2020 campaign, we secured $400 for the Bulgarian Children's Pulmonary Hospital in Tryavna. Our goal was to bolster the educational arsenal available to these young patients. Thanks to the funds, the hospital enriched its collection with new workbooks and toys, thus serving to entertain and educate. The workbooks ignited young minds, kindling their cognitive capacities, while the toys infused joy and a semblance of regular childhood, fostering a playful learning environment.`,
			`Furthermore, we set aside a slice of our funds to upgrade the hospital's kitchen facilities. The dedicated staff, who work endlessly to craft wholesome meals for their young charges, greatly benefited from the modern equipment. This not only optimized the culinary process but also ensured that every meal served was nutrient-packed, vital for the children's recuperation and overall health.`
		],
		gallery: [
			`initiative1/1.jpg`,
			`initiative1/2.jpg`,
			`initiative1/3.jpg`,
			`initiative1/5.jpg`,
			`initiative1/6.jpg`,
			`initiative1/7.jpg`,
			`initiative1/8.jpg`,
			`initiative1/9.jpg`
		]
	},
	{
		path: `/Kyiv`,
		title: 'Kyiv Center for Pediatric Cardiology and Cardiac Surgery',
		content: [
			`Funds raised: $1200`,
			`Supplies Purchased: surgical optics`,
			`Through our second campaign of 2020, our team raised $1200 in funds for Центр Дитячої Кардіології Та Кардіохірургії, or the Kyiv Center for Pediatric Cardiology and Cardiac Surgery. This achievement allowed us to make a significant impact on the lives of children requiring specialized cardiac care.`,
			`The primary objective of our campaign was to support the center in acquiring precise, brand-new surgical optics. The Kyiv Center for Pediatric Cardiology and Cardiac Surgery is a crucial medical facility that performs approximately 1,500 operations on children and 200 operations on newborns each year. These delicate procedures require the highest level of precision and accuracy to ensure successful outcomes.`,
			`The funds raised through our campaign played a vital role in enabling the center to acquire state-of-the-art surgical optics. These advanced instruments provide the surgical team with enhanced visualization during procedures, allowing them to perform intricate cardiac surgeries with greater precision. The use of high-quality surgical optics significantly improves the success rates of operations on the hearts of newborns and children.`,
			`UPDATE: The Kyiv Center was recently featured on Ukrainian news for their groundbreaking success on correcting a newborn's congenital heart defect, only minutes after the C-section. Read more at the following link:`,
			<a href="https://english.nv.ua/life/ukrainian-doctors-perform-world-s-first-heart-surgery-on-newborn-immediately-after-birth-50468367.html" target='_blank'>https://english.nv.ua/life/ukrainian-doctors-perform-world-s-first-heart-surgery-on-newborn-immediately-after-birth-50468367.html</a>
		],
		gallery: [
			`initiative2/1.jpg`,
			`initiative2/2.jpg`,
			`initiative2/3.jpg`,
			`initiative2/4.jpg`,
			`initiative2/5.jpg`,
			`initiative2/6.jpg`,
			`initiative2/7.jpg`,
			`initiative2/8.jpg`,
			`initiative2/9.jpg`,
			`initiative2/10.jpg`,
			`initiative2/phototherapylamp.jpeg`
		]
	},
	{
		path: `/Lviv`,
		title: `Lviv's Early Childhood Pediatric Center at St. Nicholas' Hospital`,
		content: [
			`Funds raised: $2500`,
			`Supplies purchased: vein-finder for neonates and phototherapy lamps to treat hyperbilirubinemia in newborns`,
			`In our 2022 campaign, we once again centered our efforts on Ukraine, a country profoundly impacted by a devastating war. The tragic ongoing conflict claimed countless lives and led to the displacement of millions, with children bearing the brunt of its consequences.`,
			`Located in Lviv, the Early Childhood Department of St. Nicholas Hospital emerged as a beacon of hope. The facility, equipped with 30 beds - 25 dedicated to pediatric patients and 5 specifically for rehabilitating infants born prematurely or those critically ill in their inaugural year - served as an essential medical sanctuary. Besides offering a broad spectrum of treatments to infants diagnosed with respiratory, gastrointestinal, and urinary ailments, this department placed significant emphasis on the early detection of congenital or associated anomalies. Notably, in the first quarter of 2022 alone, the diligent staff treated over 40 infants for SARS-CoV-2, ensuring their successful recovery.`,
			`With the unwavering support of our donors, we successfully raised $2500, enabling the purchase of the "AIMVEIN PRO 2.0 PLUS" for the Pediatric Center. This state-of-the-art vein-finder greatly overhauled the hospital's surgical venipuncture, significantly reducing the trauma and pain traditionally associated with these procedures for the young infants. With the integration of this equipment, the hospital was in a stronger position to efficiently aid at least 30 children on a daily basis, many of whom were just a few months old.`,
			`Read more at our GoFundMe link below.`,
			<a href="https://www.gofundme.com/f/fundraiser-for-ukrainian-childrens-hospital" target='_blank'>https://www.gofundme.com/f/fundraiser-for-ukrainian-childrens-hospital</a>
		],
		gallery: [
			`initiative3/1.jpg`,
			`initiative3/2.jpg`,
			`initiative3/3.jpg`,
			`initiative3/4.jpg`,
			`initiative3/5.jpg`,
			`initiative3/6.jpg`,
			`initiative3/7.jpg`,
			`initiative3/8.jpg`
		]
	},
	{
		path: `/Lviv2`,
		title: `Western Ukrainian Specialized Children's Medical Centre in Lviv, Ukraine`,
		content: [
			`Funds raised: $2000`,
			`Supplies purchased: lab reagants`,
			`In the throes of the ongoing Ukrainian conflict, our focus zeroed in on the Western Ukrainian Specialized Children's Medical Centre (WUSCMC). This critical institution annually caters to 7,000 to 7,500 children grappling with formidable challenges such as cancer, rare diseases, or the pressing need for organ transplants. Amidst the chaos of the conflict, this laboratory carried out 11 successful kidney transplants, with projections of 6-7 more before year's end. With your invaluable assistance, our campaign's objective succeeded in raising $2000 to secure vital lab reagents, including DNA typing trays, agarose, TBE Buffer, and Taq Polymerase. These reagents, essential for pinpointing organ-donor compatibility, found their home in WUSCMC's state-of-the-art PCR laboratory. Your donations played a monumental role in the life-altering transformations of at least 12 children annually. To offer more insight regarding financials, please check the GoFundMe link here:`,
			<a href='https://www.gofundme.com/f/lab-reagents-for-ukrainian-childrens-hospital?utm_campaign=p_lico+share-sheet-first-launch&utm_medium=copy_link&utm_source=customer' target='_blank' >https://www.gofundme.com/f/lab-reagents-for-ukrainian-childrens-hospital?utm_campaign=p_lico+share-sheet-first-launch&utm_medium=copy_link&utm_source=customer</a>,
			`However, our proudest announcement is the life-changing difference your contributions have made. Thanks to your support, a 5-year-old girl named Snizhanka, previously tethered to the constraints of hemodialysis due to a complex kidney disease, has received a successful kidney transplant. The surgery, an end to her years of relentless medical treatments, promises her a newfound chance at a normal life. As a team, we're immeasurably grateful for your unwavering support. Our journey with you doesn't end here. Keep an eye on our updates, and thank you once again for being a beacon of hope in these trying times.`
		],
		gallery: [
			`initiative4/lviv2pic1.PNG`,
			`initiative4/lviv2pic2.PNG`,
			`initiative4/lviv2pic3.PNG`
		],
		additional: [
			{
				title: `Updates!`,
				content: [
					`We are thrilled to announce another remarkable transplant that occurred thanks to YOUR donations as part of our previous fundraising campaign for PCR reagents!`,
					`Yuriy is 13 years old and comes from Zolochiv (Lviv region). He was diagnosed with kidney failure at the age of 7. As the disease progressed, his mother, without hesitation, agreed to become a donor for her son. The Center's Clinical Diagnostic Laboratory (the laboratory which we donated the reagents to) conducted all necessary immunological studies and confirmed compatibility.`,
					`We once again wanted to thank everyone for their support. We gave Yuriy another chance at life, and we believe that that is truly priceless. We couldn’t have done this without you.`,
					`Please stay tuned for our next campaign, which will be coming shortly!`
				],
				gallery: [
					`initiative4/yuriy1.jpg`,
					`initiative4/yuriy2.jpg`,
					`initiative4/yuriy3.jpg`
				]
			}
		],
	},
	{
		path: `/Lviv3`,
		title: `Western Ukrainian Specialized Children's Medical Centre in Lviv, Ukraine`,
		content: [
			`Funds raised: $2000`,
			`Supplies purchased: lab reagants for organ transplants`,
			`For ASH's fifth fundraising campaign, we once again returned to the Western Ukrainian Specialized Children's Medical Centre in Lviv, were we successfully raised $2000 to purchase reagents thanks to the generous contributions of our supporters! Reagents such as these have enabled 104 children in the past year to receive accurate and prompt matches for kidney, lungs, and bone marrow transplants for children. More specifically, HLA-typing reagents are used to treat various blood diseases, such as blood cancers, bone marrow diseases, and various immune system diseases.`,
			`From the bottom of our hearts, we thank each one of you who has financially supported, or simply just shared our fundraiser. It’s difficult to put into words how much we truly appreciate your contributions, time, and support.`,
			`We would also like to announce the success story of two-year-old Maksimko, the smallest patient to have a kidney transplant in Lviv. The staff at the specialized children’s hospital at WUSCMC have spent almost a year and a half preparing for this operation. In short, Makismko has successfully received his transplant kidney from a 40-year-old donor and was discharged home as of June, 2024. Your direct donations have contributed to the success stories of patients like Maksimko and many others.`,
			`Read more at our GoFundMe link below.`,
			<a href="https://www.gofundme.com/f/reagents-for-organ-transplants-for-ukrainian-children" target="_blank" rel="noopener">https://www.gofundme.com/f/reagents-for-organ-transplants-for-ukrainian-children</a>
		],
		gallery: [
			`initiative5/1.jpeg`,
			`initiative5/2.jpeg`,
			`initiative5/3.jpeg`
		],
		additional: [
			{
				title: `Additional`,
				content: [
					`The full story of Makismko for those who are interested:`,
					`Two-year-old Maksimko is the smallest patient to have a kidney transplant in Lviv. Before the complex operation of a baby aged 2 years 4 months and weighing 10 kg, the multidisciplinary team #specialchildrenshospital has been preparing for almost a year and a half. "It's going to be difficult, but together we'll make it! "the words of children's nephrologist Roman andruneviča's mom maksimka mentions or not daily. Now she is thanking fate that the specialized treatment of her son went to Клініка дитячої нефрології, діалізу та трансплантації нирки. The defect of the development of the urinary system in the fetus was diagnosed still during the mother's pregnancy. Then the situation was greatly complicated by a rupture of the right kidney, which happened at 28 weeks. After birth, the baby was in the intensive care for over a month, and underwent two operations - for 10 and 17 days of life. "We met Maksimko when he turned two months old. First, they performed conservative therapy, monitored kidney indicators, performed blood transfusions to treat severe anemia, vaccinated, etc. That is, the entire medical team of the Center worked," says Roman Andrunevich. In February 2023, the child began peritoneal dialysis due to deteriorating health. To live fully, the boy needed a transplant as soon as possible. Maksimko waited a chance to rescue while in line at the donor organ in #Zusdmc. Kidney for our little patient was "found" in May this year. The donor was an adult, 40-year-old man. The operating team of surgeons and anesthesiologists of the Center together with colleagues-transplantologists of the First Medical Association of Lviv successfully transplanted a kidney. Two weeks after the transfer, Maximka was discharged home. In the circle of the family, the process of recovery is faster and more effective, doctors say. During an impromptu discharge, the doctors wished the family to come to them only for checkups or just to visit.`
				],
				gallery: []
			}
		]
	},
	{
		path: `/Front`,
		title: `Ukrainian Front Lines`,
		content: [
			`Our organization has pooled nearly $3300 "dining dollars" from our respective campuses to purchase over 50 boxes of protein bars and over 150 instant oatmeal meals. We are currently shipping all the boxes through MEEST to our partner organization, Wings of Hope, in Ukraine. They will execute the distribution of supplies to families living on the front lines.`
		],
		gallery: [
			`initiative6/box1.jpg`,
			`initiative6/box2.jpg`,
			`initiative6/box3.jpg`,
			`initiative6/box4.jpg`
		]
	}
];

/*
initiatives.forEach(initiative => {
	console.log(initiative.gallery);
	if (initiative.additional) {
		initiative.additional.forEach(section => {
		console.log(section.gallery);
		});
	}
	});
*/

function App() {
	return (
		<Router>
			<Header />
			<Routes>
				<Route path="/" element={<Home />} />
				{initiatives.map((initiative) => (
				<Route
					key={initiative.path}
					path={initiative.path}
					element={
					<InitiativePage
						title={initiative.title}
						content={initiative.content}
						gallery={initiative.gallery}
						additional={initiative.additional}
					/>
					}
				/>
				))}
			</Routes>
		</Router>
	);
}

export default App;
